import React, { useState } from "react";
import { FilePond, registerPlugin } from "react-filepond";

import "filepond/dist/filepond.min.css";

// Import the Image EXIF Orientation and Image Preview plugins
// Note: These need to be installed separately
// `npm i filepond-plugin-image-preview filepond-plugin-image-exif-orientation --save`
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileRename from "filepond-plugin-file-rename";

// Register the plugins
registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateType,
  FilePondPluginFileValidateSize,
  FilePondPluginFileRename
);

const FileUpload = (props) => {
  const [files, setFiles] = useState([]);

  const filerenamefunction = (file)=>{  
  	let fileName=file.basename;  
	while(fileName.trim().length === 0 || fileName.length > props.maxFileNameLength )  {
      	fileName = prompt('Enter a file name under '+ props.maxFileNameLength +' characters. Do not enter file extension.', file.basename );	    
	};
	return `${fileName}${file.extension}`; 

	};
  // return file count on upload file
  const onUpdateFiles = (fileItems) => {
    setFiles(fileItems);
    props.onChange(fileItems);
    props.onBlur(fileItems);
    //console.log(fileItems);
  };

  // on error, return error message
  const onError = (error, file, status) => {
    //console.log("error = ", error);
    //console.log("file = ", file);
    //console.log("status = ", status);
    // return error message
    props.onChange(status.main + ", " + status.sub);
    props.onBlur(status.main + ", " + status.sub);
  };
  
  

 function fileTypeSwitch(param) {
    let types = [];
    let s = "any";
    if (param !== undefined) {
      if (Array.isArray(param)) {
        types = param; // types = list of type
      } else {
        types.push(param.toString().toLowerCase()); // types = single format
      }
    } else {
      types.push(s); // types = any								 
    }

    //console.log("list if file types = ", types);

    let allowType = [];
    types.forEach(function (type, i) {
      switch (type) {
        case "pdf":
          allowType.push("application/pdf");
          break;
        case "image_basic":
          allowType.push("image/jpeg");
          allowType.push("image/png");
          allowType.push("image/gif");
          break;
        case "image_all":
        case "image":
          allowType.push("image/*");
          break;
        case "office":
          // doc docx
          allowType.push(".doc");
          allowType.push("application/msword");
          allowType.push(
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          );
          // rtf
          allowType.push("application/rtf");
          // xls, xlsx
          allowType.push(".xls");
          allowType.push("application/vnd.ms-excel");
          allowType.push(
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          );
          // ppt, pptx
          allowType.push(".ppt");
          allowType.push("application/vnd.ms-powerpoint");
          allowType.push(
            "application/vnd.openxmlformats-officedocument.presentationml.presentation"
          );
          // txt. csv
          allowType.push("application/txt");
          allowType.push("text/csv");
          break;
        case "zip":
          allowType.push("application/zip");
          break;
        case "text":
          allowType.push("text/plain");
          allowType.push("text/csv");
          break;
        case "any":
        default:
          allowType.push("*/*");
          break;
      }
    });

    //console.log("--allowType = ", allowType);
    return allowType;
  }

  return (
    <div className="inputbox__container">
      <label
        className={`inputbox__label ${
          props.isDisabled ? "inputbox__label--disabled" : ""
        }
            ${props.hasError ? "inputbox__label--error" : ""}     
        `}
        style={{
          display:
            props.label === undefined ||
            props.label === null ||
            props.label.length === 0
              ? "none"
              : "block"
        }}
      >
        {props.label}
        <span
          className={`inputbox__required  ${
            props.isRequired
              ? "inputbox__required--show"
              : "inputbox__required--hide"
          }`}
        >
          *
        </span>
      </label>
      <span
        className="inputbox__error"
        style={props.hasError ? {} : { display: "none" }}
      >
        {props.errorMessage}
      </span>
      <br />
      <FilePond
        files={files}
        //onupdatefiles={setFiles}
        allowMultiple={true}
        maxFiles={props.numberOfFiles ? props.numberOfFiles : 1}
        server={props.uploadApi}
        name="files"
        labelIdle={
          props.instructionMessage
            ? props.instructionMessage
            : 'Drag & Drop your files or <span class="filepond--label-action">Browse</span>'
        }
        credits={false}
        acceptedFileTypes={fileTypeSwitch(props.fileType)}   
        fileRenameFunction= {filerenamefunction}
        onupdatefiles={onUpdateFiles}       
        onerror={onError}
        maxFileSize={props.fileSize ? props.fileSize : "5MB"}
        instantUpload={!props.uploadButton}
      />
      <span className="inputbox__help">{props.helpMessage}</span>
    </div>
  );
};

export default FileUpload;